import React from 'react';

import { Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { BodyStyles } from './Body.styles';
import type { InstagramPostComponentsProps } from './types';

export function Body(props: InstagramPostComponentsProps): React.JSX.Element {
	const { loading, size, previewImageUrl } = props;

	const bodyStyles = BodyStyles({ size });

	if (loading) {
		if (size === 'xsmall') {
			return (
				<SkeletonContainer loading={loading} className="h-full w-full" data-testid="empty-container">
					<Rectangle className="h-full w-full" />
				</SkeletonContainer>
			);
		}
		return (
			<SkeletonContainer loading={loading} className={bodyStyles} data-testid="empty-container">
				<Rectangle className="h-full w-full" />
			</SkeletonContainer>
		);
	}

	return <img data-testid="body-image" src={previewImageUrl} className={bodyStyles} alt="" aria-hidden />;
}
